import {
  faEllipsis,
  faPencilAlt,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "Features/Tenants/tenants.index.css";
import { useAppDispatch } from "Store/hooks";
import { setCurrentOrganization, setIsModalOpen } from "../../redux/slice";
import { deleteOrganization, getAllOrganizations } from "../../redux/thunks";
import { setErrorState } from "Components/Basic/ErrorBoundary/redux/slice";
import { Dropdown, MenuProps, Popconfirm } from "antd";
import { IOrganizationFilter } from "../../redux/types";
import { setLoadingState } from "Components/Basic/full_page_loader/redux/slice";
import { OrganizationConstants } from "Constants";

import "Features/Tenants/tenants.index.css";

export const ActionRenderer = (_: any, record: any) => {
  const getOrganizations = () => {
    let organizationFilter: IOrganizationFilter = {
      name: null,
    };
    dispatch(setLoadingState(true));
    dispatch(getAllOrganizations(organizationFilter))
      .unwrap()
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(setLoadingState(false));
      });
  };
  const dispatch = useAppDispatch();

  const deleteSelectedOrganization = () => {
    dispatch(setLoadingState(true));
    dispatch(deleteOrganization(record.id))
      .unwrap()
      .then(() => {
        dispatch(
          setErrorState({
            message: "Success",
            description: OrganizationConstants.ORGANIZATION_DELETD_MESSAGE,
            placement: "topRight",
            type: "success",
          })
        );
        getOrganizations();
      })
      .catch((err: any) => {
        dispatch(setLoadingState(false));
        dispatch(
          setErrorState({
            message: "Error",
            description: err.message,
            placement: "topRight",
            type: "error",
          })
        );
      });
  };

  const handleDelete = () => {
    deleteSelectedOrganization();
  };

  const handleEdit = () => {
    dispatch(setCurrentOrganization(record));
    dispatch(setIsModalOpen(true));
  };

  const items: MenuProps["items"] = [
    {
      label: (
        <div onClick={handleEdit} className={"action-items"}>
          <FontAwesomeIcon
            className="action-items-icon"
            color="#4fa3ec"
            icon={faPencilAlt}
          />{" "}
          {OrganizationConstants.EDIT_ORGANIZATION_TEXT}{" "}
        </div>
      ),
      key: "1",
    },
    {
      label: (
        <Popconfirm
          title={OrganizationConstants.ORGANIZATION_DELETION_TITLE_TEXT}
          description={
            OrganizationConstants.ORGANIZATION_DELETION_VERIFICATION_TEXT
          }
          onConfirm={handleDelete}
        >
          <div className={"action-items action-items-red"}>
            <FontAwesomeIcon
              className="action-items-icon action-items-icon-red"
              icon={faTrashAlt}
            />
            {OrganizationConstants.DELETE_ORGANIZATION_TEXT}
          </div>
        </Popconfirm>
      ),
      danger: true,
      key: "2",
    },
  ];
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Dropdown menu={{ items }} trigger={["click"]}>
        <FontAwesomeIcon
          style={{ cursor: "pointer" }}
          icon={faEllipsis}
          rotation={90}
        />
      </Dropdown>
    </div>
  );
};
